var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExscapelogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 43,
    viewBox: "0 0 84 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 135.446V0H83.3333V9.25926L26.6421 19.1898V116.257L83.3333 126.157V135.446H0Z",
    fill: "url(#paint0_linear_138_30)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.666 67.5808V63.838L70.7767 61.3428V70.076L41.666 67.5808Z",
    fill: "url(#paint1_linear_138_30)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_138_30",
    x1: -0.499998,
    y1: -0.00000105411,
    x2: 83,
    y2: 135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0133328,
    stopColor: "#2B31EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3109E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_138_30",
    x1: 41.4914,
    y1: 61.3428,
    x2: 42.8476,
    y2: 73.2224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0133328,
    stopColor: "#2B31EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3109E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExscapelogo);
export default __webpack_public_path__ + "static/media/exscapelogo.f7de12a5b96d3310ca4e4f41c5067f6e.svg";
export { ForwardRef as ReactComponent };